import {useState} from 'react'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import FormErrors from '../components/FormErrors'
import {login} from '../lib/allauth'
import {useConfig} from '../auth'
import ProviderList from '../socialaccount/ProviderList'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [response, setResponse] = useState({fetching: false, content: null})
    const config = useConfig()
    const hasProviders = config.data.socialaccount?.providers?.length > 0

    function submit() {
        setResponse({...response, fetching: true})
        const payload = {password};
        if (email.indexOf("@") > -1) {
            payload.email = email;
        } else {
            payload.username = email;
        }
        login(payload).then((content) => {
            setResponse((r) => {
                return {...r, content}
            })
        }).catch((e) => {
            console.error(e)
            window.alert(e)
        }).then(() => {
            setResponse((r) => {
                return {...r, fetching: false}
            })
        })
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            submit();
        }
    }

    return (
        <div className={'centeredForm'}>

            <FormErrors errors={response.content?.errors}/>

            <div>
                <label>Email / Username</label>
                <div>
                    <input value={email}
                           onChange={(e) => setEmail(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type='email'
                           required/>
                </div>
                <FormErrors param='email' errors={response.content?.errors}/>
                <FormErrors param='username' errors={response.content?.errors}/>
            </div>
            <div>
                <label>Password</label>
                <div className="password-input-wrapper">
                    <input value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type={showPassword ? 'text' : 'password'}
                           required/>
                    <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword((visible) => !visible)}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}/>
                    </button>
                </div>
                <FormErrors param='password' errors={response.content?.errors}/>
            </div>

            <div className={'fieldLogin'}>
                <button disabled={response.fetching} onClick={() => submit()}>Login</button>
                <Link to={'/account/password/reset'}>Forgot your password?</Link>

            </div>

            <hr/>

            {hasProviders &&
                <div className={'socialProviders'}><ProviderList callbackURL='/account/provider/callback'/></div>}
        </div>
    )
}
